export const SFH_ALLOWED_STATES = [
  { code: 'TX', name: 'Texas' },
  { code: 'CA', name: 'California' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'OR', name: 'Oregon' },
  { code: 'CO', name: 'Colorado' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'WA', name: 'Washington' },
  { code: 'MO', name: 'Missouri' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'IL', name: 'Illinois' },
  { code: 'MI', name: 'Michigan' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'VA', name: 'Virginia' },
];

export const isStateAllowedForSfh = (stateRegion) =>
  SFH_ALLOWED_STATES.some(
    (state) => state.code === String(stateRegion || '').toUpperCase(),
  );
